export const PARAMETER_NAMES = ['250 Hz', '500 Hz', '1 kHz', '2 kHz', '3 kHz', '4 kHz', '6 kHz', '8 kHz', 'sso'];
